import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Icon, Tappable } from '@vectord/components';
import classNames from 'classnames';

import {
  BULK_DELETE_SBAT_GROUP_MODAL_STAGES,
  setDeleteSbatGroupsModalStage,
} from 'features/classCreation';
import styles from './DeleteSbatGroupButton.module.scss';

export default function DeleteSbatGroupsButton({ disabled }) {
  const dispatch = useDispatch();

  const handleDelete = useCallback(() => {
    dispatch(
      setDeleteSbatGroupsModalStage(BULK_DELETE_SBAT_GROUP_MODAL_STAGES.info)
    );
  }, [dispatch]);

  return (
    <Tappable
      className={classNames('btn btn-danger btn-outlined m-r-xs ', {
        [styles.deleteSbatGroupButton]: disabled,
      })}
      onClick={handleDelete}
      disabled={disabled}
    >
      <Icon
        name="trash"
        className="m-r-xxs"
      />
      Delete Class
    </Tappable>
  );
}
